/**
 * EDD (Enhanced Customer Due Diligence) 문서 변수 정의.
 * Word 템플릿 [[변수]] 와 1:1 — 임의 필드 추가 금지.
 */
export type EddFieldType = 'text' | 'date' | 'person';

export const EDD_KEYS = [
  'edd_pep_name',
  'edd_pep_role',
  'edd_source_of_fund_wealth',
  'edd_additional_info',
  'edd_justification',
  'edd_senior_mgmt_name',
  'edd_senior_mgmt_designation',
  'edd_approval_date',
] as const;

export type EddFieldKey = (typeof EDD_KEYS)[number];

/** 논리 템플릿 ID — 실제 저장은 task config 첨부 템플릿명(/edd|enhanced/i) 매칭. */
export const EDD_TEMPLATE_ID = 'TMP_EDD';
export const EDD_DOC_LABEL = 'EDD';

export const EDD_APPROVAL_OPTIONS = [
  { value: 'edd_approved', label: 'Approved' },
  { value: 'edd_not_approved', label: 'Not approved' },
] as const;

const OVERRIDES: Record<string, string> = {
  pep_name: 'Higher Risk Customer / PEP Name',
  pep_role: "Customer/PEP's Role",
  source_of_fund_wealth: 'Source of Fund / Source of Wealth',
  additional_info: 'Additional Information on Customer and Beneficial Owner',
  justification: 'Justification',
  senior_mgmt_name: 'Name of Senior Management',
  senior_mgmt_designation: 'Position / Designation',
  approval_date: 'Approval Date',
};

function stripPrefix(key: string): string {
  return key.replace(/^edd_/, '');
}

export function labelize(key: string): string {
  const bare = stripPrefix(key);
  if (OVERRIDES[bare]) return OVERRIDES[bare];
  return bare
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function typeOf(key: string): EddFieldType {
  const bare = stripPrefix(key);
  if (/(_date|_dob)$/.test(bare) || bare === 'approval_date') return 'date';
  if (/pep_name|senior_mgmt_name/.test(bare)) return 'person';
  return 'text';
}

export function isOptional(key: string): boolean {
  return /(_date|_dob)$/.test(key) || key === 'edd_justification' || key === 'edd_additional_info';
}
